import api from './api';

class TenantRequestService {
  // Check status of a tenant request using subdomain and email
  async checkRequestStatus(subdomain, email) {
    try {
      console.log(`Checking status for request with subdomain: ${subdomain} and email: ${email}`);
      const response = await api.post('/tenant-requests/check-status', {
        subdomain,
        email
      });
      return response.data;
    } catch (error) {
      console.error('Error checking tenant request status:', error);
      throw error;
    }
  }

  // Check if a subdomain is available
  async checkSubdomainAvailability(subdomain) {
    try {
      console.log(`Checking availability for subdomain: ${subdomain}`);
      const response = await api.get(`/tenants/check-subdomain/${subdomain}`);
      
      console.log('Subdomain check response:', response.data);
      return {
        available: response.data.available === true,
        message: response.data.message || (response.data.available ? 
          'Subdomain is available' : 'Subdomain is already taken')
      };
    } catch (error) {
      console.error('Error checking subdomain availability:', error);
      
      // If there's a 409 status, the subdomain is definitely taken
      if (error.response && error.response.status === 409) {
        return { available: false, message: 'Subdomain already taken' };
      }
      
      // For other errors, log and provide a clear response
      if (error.response) {
        console.error('Server response:', {
          status: error.response.status,
          data: error.response.data
        });
      }
      
      // Default to available for network errors to prevent registration from being blocked
      return { 
        available: true, 
        message: 'Could not verify subdomain availability, but you can proceed' 
      };
    }
  }

  // Get a specific tenant request by ID
  async getRequestById(id) {
    try {
      const response = await api.get(`/tenant-requests/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching tenant request with ID ${id}:`, error);
      throw error;
    }
  }

  // Submit a new tenant request
  async submitTenantRequest(requestData) {
    try {
      console.log('Submitting tenant request:', {
        name: requestData.name,
        subdomain: requestData.subdomain,
        phone: requestData.phone,
        location: requestData.location,
        industry: requestData.industry,
        companySize: requestData.companySize,
        requestedBy: requestData.requestedBy ? {
          ...requestData.requestedBy,
          password: '[REDACTED]' // Don't log the actual password
        } : undefined,
        status: requestData.status
      });
      
      const response = await api.post('/tenant-requests', requestData);
      console.log('Tenant request submitted successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error submitting tenant request:', error);
      if (error.response) {
        console.error('Server response:', {
          status: error.response.status,
          data: error.response.data
        });
      }
      throw error;
    }
  }

  // Submit feedback or additional information for a tenant request
  async submitAdditionalInfo(id, data) {
    try {
      const response = await api.post(`/tenant-requests/${id}/additional-info`, data);
      return response.data;
    } catch (error) {
      console.error('Error submitting additional information:', error);
      throw error;
    }
  }
}

export default new TenantRequestService();
